module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/gift-christmas-pray.d3fa747b.png";